'use client';

import { initializeMediaConfig } from '@bgzt/media';
import { base64ToObject } from '@bgzt/utils';
import { useEffect } from 'react';
import { useAppContext } from '~/contexts/AppContext/AppContext';
import { useLowPriorityEffect } from '~/hooks';
import { APP_LOG_CONTEXT_STORAGE_KEY, togglePullToRefresh } from '~/services/app-interface';
import { initializeClientAuth } from '~/services/auth';
import { getQueryParam } from '~/utils';

type Props = {
  token: string;
  uid: number;
};

export const ClientInitializer = ({ token, uid }: Props) => {
  const { setAppLogContext } = useAppContext();

  initializeClientAuth(token, uid);
  useLowPriorityEffect(() => {
    togglePullToRefresh(true);
    initializeMediaConfig({ env: process.env.NEXT_PUBLIC_ENV });
  }, []);

  const initializeAppLogContext = () => {
    const logContext =
      getQueryParam('logContext') || globalThis.window.sessionStorage.getItem(APP_LOG_CONTEXT_STORAGE_KEY);

    if (!logContext) return;

    globalThis.window.sessionStorage.setItem(APP_LOG_CONTEXT_STORAGE_KEY, logContext);
    const decodedLogContext = base64ToObject(logContext);
    setAppLogContext?.(decodedLogContext);
  };

  useEffect(() => {
    initializeAppLogContext();
    initializeMediaConfig({ env: process.env.NEXT_PUBLIC_ENV });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
